import girderEvents from 'girder/events';

export default girderEvents;



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/events.js